import React from "react";
import { SortableHandle, SortableElement } from "react-sortable-hoc";
import { TrWrapper, Handle, PriorityCell, PriorityCellContent } from "../style/Style";
import { formatLeadQuota, getBrokerName, getStatusIndicator } from "../index";
import handler from "../../../assets/Images/icons/faDotsVertical.svg";

const RowHandler = SortableHandle(() => (
  <Handle>
    <img src={handler} alt="drag handle" />
    <img src={handler} alt="drag handle" />
  </Handle>
));

const BrokerRow = ({ rowData, onEdit, onDelete, actionloader, canDeleteBroker, canEditBroker }) => {
  const handleEdit = () => {
    if (onEdit) {
      onEdit(rowData);
    }
  };

  const handleDelete = () => {
    if (onDelete && rowData.id) {
      onDelete(rowData.id);
    }
  };

  return (
    <TrWrapper className="table-row">
      <PriorityCell>
        <PriorityCellContent>
          <RowHandler />
        </PriorityCellContent>
      </PriorityCell>
      <td>{getBrokerName(rowData)}</td>
      <td>{getStatusIndicator(rowData)}</td>
      <td>{formatLeadQuota(rowData)}</td>
      <td>{rowData.accepted_last_month || "0"}/{rowData.rejected_last_month || "0"}</td>
      <td className="action">
        {canEditBroker && (
          <button
            className="accept"
            onClick={handleEdit}
            disabled={actionloader}
          >
            Edit
          </button>
        )}
        {canDeleteBroker && (
          <button
            className="reject"
            onClick={handleDelete}
            disabled={actionloader}
          >
            Delete
          </button>
        )}
      </td>
    </TrWrapper>
  );
};

export const SortableItem = SortableElement((props) => <BrokerRow {...props} />);

export default BrokerRow;

